<template>
  <div class="sec">
    <h2>Parralax Scrolling Effect</h2>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus
      voluptatem cumque esse ducimus vel natus enim cupiditate eum sit, quas
      eaque, ipsum accusantium minima quae animi repellat magnam temporibus
      veniam! Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur,
      odio aut animi hic deleniti, porro eveniet doloremque sunt necessitatibus
      fugiat error suscipit numquam ratione vero unde quasi explicabo
      consequatur soluta.
    </p>
    <br />
    <p>
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Impedit,
      doloribus cum est accusantium dolores veniam voluptatibus ipsum
      consequuntur? Eveniet, assumenda at eaque sapiente fugit earum temporibus
      provident esse illum consectetur. Lorem ipsum dolor sit amet consectetur,
      adipisicing elit. A fugiat commodi maiores sit hic, doloribus error sunt
      totam deleniti placeat, omnis quisquam aliquam velit facilis odio officia
      in, reiciendis minus?
    </p>
  </div>
</template>

<script>
export default {
  name: "about",
};
</script>

<style lang="scss" scoped>
.sec {
  position: relative;
  padding: 100px;
  background: #1c0522;

  h2 {
    font-size: 3.5em;
    margin-bottom: 10px;
    color: #fff;
  }
  p {
    font-size: 1.3em;
    color: #fff;
  }
}
</style>
